import React, { FC, useMemo } from "react";
import { getTextFromHtml } from "src/utils/getTextFromHtml";
import { TextEditorView } from "src/components/TextEditor/TextEditorView";

interface Props {
  title: string;
  description: string;
}

export const TitledEditorView: FC<Props> = ({ title, description }) => {
  const descriptionText = useMemo(
    () => getTextFromHtml(description),
    [description]
  );

  if (!descriptionText) return null;

  return (
    <div className="flex flex-col gap-3">
      <h2>{title}</h2>
      <TextEditorView>{description}</TextEditorView>
    </div>
  );
};
